import { Message } from "@cohesive/api-client";

/**
 * Harness edition of `parseMessageHistory`: keep user/assistant/tool-call
 * rows, stitch each tool result onto its call, drop the tool rows. The legacy
 * stitch only looks at the tool rows immediately following a call, which is
 * enough for the Go loop's strictly sequential transcript; a harness turn with
 * background agents interleaves sidechain rows, so a call's result can land
 * many rows later. Stitch by `tool_call_id` across the whole list instead.
 */
export function parseHarnessMessageHistory(messages: Message[]): Message[] {
  const resultsByCallId = new Map<string, Message>();
  for (const message of messages) {
    if (message.origin === "tool" && message.tool_call_id) {
      resultsByCallId.set(message.tool_call_id, message);
    }
  }

  const kept: Message[] = [];
  for (const message of messages) {
    switch (message.origin) {
      case "user":
      case "assistant":
        kept.push(message);
        break;
      case "assistant-tool-call":
        for (const toolCall of message.tool_calls ?? []) {
          const result = resultsByCallId.get(toolCall.id);
          if (result?.result) toolCall.result = result.result;
          // A result row settles the call: history carries no per-call
          // `status`, and a call whose result never landed stays as it is.
          if (result && toolCall.status === "processing")
            toolCall.status = "done";
        }
        kept.push(message);
        break;
    }
  }
  return kept;
}
